export const CaseStatus = {
  NEW: 'New',
  CLONING: 'Cloning',
  CLONING_FAILED: 'Cloning Failed',
  DOCUMENT_UPLOAD: 'Document Upload',
  WAITING_FOR_DOCUMENT_PROCESSING: 'Waiting For Document Processing',
  PREPROCESSING_ERROR: 'Preprocessing Error',
  READY_FOR_AI_PROCESSING: 'Ready For AI Processing',
  CONFIGURING_AI_PIPELINE: 'Configuring AI Pipeline',
  AI_PAGINATION_PROCESSING: 'AI Pagination Processing',
  AI_PAGINATION_CANCELLED: 'AI Pagination Cancelled',
  AI_PAGINATION_FAILED: 'AI Pagination Failed',
  AI_PAGINATION_COMPLETE: 'AI Pagination Complete',
  MEDICAL_MATCH_PROCESSING: 'Medical Match Processing',
  MEDICAL_MATCH_CANCELLED: 'Medical Match Cancelled',
  MEDICAL_MATCH_FAILED: 'Medical Match Failed',
  MEDICAL_MATCH_COMPLETE: 'Medical Match Complete',
  AI_TIMELINE_PROCESSING: 'AI Timeline Processing',
  AI_TIMELINE_CANCELLED: 'AI Timeline Cancelled',
  AI_TIMELINE_FAILED: 'AI Timeline Failed',
  AI_TIMELINE_COMPLETE: 'AI Timeline Complete',
  READY_FOR_REVIEW: 'Ready For Review',
  CLOSED: 'Closed',
};

export type CaseStatus = (typeof CaseStatus)[keyof typeof CaseStatus];
